import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
const Wrapper = (props) => {
    return (props.show !== false && props.hide !== true &&
        <div {...omit(props, ['show', 'hide'])} >{props.children}</div>
    )
}
export default Wrapper;
Wrapper.propTypes = {
    className: PropTypes.any
}